import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=5a6d0e6c&"
import script from "./EditReport.vue?vue&type=script&lang=js&"
export * from "./EditReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports